/* Kukoon cart drawer extras (2 Oct 2026):
     - the discount code box (snippets/kukoon-cart-code.liquid)
     - Meet the A-listers (snippets/kukoon-alisters.liquid), our own version
       of Rebuy's cart widget 181456, switched in Upsell Radar
   Everything is delegated on document: the drawer rewrites its own markup on
   every cart change, so nothing here holds on to an element. */
(function () {
  'use strict';
  var R = window.routes || {};
  var url = function (k, d) { return (R[k] || d) + '.js'; };
  var refresh = function (open) {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: open !== false } }));
  };
  var post = function (u, body) {
    return fetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body) }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
  };

  /* ---------------------------------------------------------- the switch
     config.json (upsell.alisters) -> remembered per browser -> html.kuk-alist
     from the next page, set early by theme.liquid. ?alist=1 / 0 for one tab. */
  var LIVE = 'kukoon.alist.live';
  try {
    var q = new URLSearchParams(location.search).get('alist');
    if (q === '1') sessionStorage.setItem('kukoon.alist', '1');
    if (q === '0') sessionStorage.setItem('kukoon.alist', '0');
    var su = (window.KukoonSearch || {}).settingsUrl || 'https://api.kukoonrugs.com/search/config.json';
    fetch(su, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      if (!j) return;
      try { if (j.upsell && j.upsell.alisters === true) localStorage.setItem(LIVE, '1'); else localStorage.removeItem(LIVE); } catch (e) {}
      // what a full basket shows, set in Upsell Radar: split | match | best
      try { var cm = j.upsell && j.upsell.cart; if (cm === 'split' || cm === 'match' || cm === 'best') localStorage.setItem('kukoon.alist.mode', cm); } catch (e) {}
    }).catch(function () {});
  } catch (e) {}
  var on = function () { return document.documentElement.classList.contains('kuk-alist'); };

  /* ---------------------------------------------------------- the chat bubble
     sat on the Checkout button. CSS hides the known containers; some chat
     widgets set their own display with !important, so while the drawer is
     open the script hides them too, and puts them back when it closes. */
  var CHAT = '#gorgias-chat-container, #gorgias-web-messenger-container, #dg-chat, #dg-chat-widget-launcher';
  function chat(hide) {
    document.querySelectorAll(CHAT).forEach(function (el) {
      if (hide) el.style.setProperty('visibility', 'hidden', 'important');
      else el.style.removeProperty('visibility');
    });
  }
  // (a script that toggled visibility made the widget redraw rather than
  // go on a PC; kukoon-cart.css hides it on every screen now, so this only
  // tidies anything left hidden when the basket closes)
  new MutationObserver(function () {
    if (!document.querySelector('[data-cart-drawer][data-active]')) chat(false);
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['data-active'] });

  /* ---------------------------------------------------------- logging */
  var logged = {};
  function track(where, action, handle, position) {
    try {
      if (!window.kukoonSearchLog) return;
      window.kukoonSearchLog('set', { term: 'alist:' + where, refinement: action, handle: handle || '',
        position: position || null, surface: 'alist' + (window.KukoonCartAB ? '-' + window.KukoonCartAB : ''),
        results: window.KukoonCartOrd === 'runner' ? 1 : window.KukoonCartOrd === 'current' ? 2 : 0,
        filters: ((window.KukoonSearch || {}).country || '') + '|' + ((window.Shopify && Shopify.currency && Shopify.currency.active) || '') });
    } catch (e) {}
  }
  // one "shown" per drawer opening, with every product offered
  function seen() {
    document.querySelectorAll('[data-kuk-alist]').forEach(function (box) {
      if (!box.offsetParent) return;
      var where = box.getAttribute('data-where') || 'cart';
      if (where !== 'empty' && !on()) return;
      // not until the row has settled on what it shows
      if (document.documentElement.classList.contains('kuk-alist-js') && !box.hasAttribute('data-ready')) return;
      var cards = box.querySelectorAll('.kal-card');
      var sig = where + ':' + [].map.call(cards, function (c) { return c.dataset.h; }).join(',');
      if (!cards.length || logged[sig]) return;
      logged[sig] = 1;
      track(where, 'shown', '', cards.length);
      cards.forEach(function (c, i) { track(where, 'offered', c.dataset.h, i + 1); });
    });
  }
  document.addEventListener('cart-drawer:open', function () { setTimeout(seen, 400); });
  document.addEventListener('kuk:alist-filled', function () { setTimeout(function () { seen(); arrows(); }, 60); });
  document.addEventListener('cart:refresh', function () { logged = {}; setTimeout(seen, 900); });

  /* ---------------------------------------------------------- A-listers: arrows */
  function arrows() {
    document.querySelectorAll('[data-kuk-alist]').forEach(function (box) {
      var row = box.querySelector('.kal-row'); if (!row) return;
      var more = row.scrollWidth - row.clientWidth > 4;
      var p = box.querySelector('.kal-prev'), n = box.querySelector('.kal-next');
      if (p) p.hidden = !more || row.scrollLeft <= 4;
      if (n) n.hidden = !more || row.scrollLeft >= row.scrollWidth - row.clientWidth - 4;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kal-nav]');
    if (!b) return;
    e.preventDefault();
    var row = b.closest('[data-kuk-alist]').querySelector('.kal-row');
    var from = row.scrollLeft, step = row.clientWidth * 0.8 * Number(b.getAttribute('data-kal-nav'));
    row.scrollBy({ left: step, behavior: 'smooth' });
    setTimeout(function () { if (row.scrollLeft === from) row.scrollLeft = from + step; arrows(); }, 450);
  });
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('kal-row')) arrows();
  }, true);
  document.addEventListener('cart-drawer:open', function () { setTimeout(arrows, 350); });
  document.addEventListener('cart:refresh', function () { setTimeout(arrows, 900); });
  window.addEventListener('resize', arrows);

  /* ---------------------------------------------------------- A-listers: a tap
     opens the rug's page; counted as "added" (the row's uptake) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-kal-open]');
    if (!a) return;
    var card = a.closest('.kal-card'), box = a.closest('[data-kuk-alist]');
    // where the card has its own Add button, opening the page is just a look
    var shop = box && box.querySelector('[data-kal-add]');
    if (card) track(box ? box.getAttribute('data-where') : 'cart', shop ? 'opened' : 'added', card.dataset.h, Number(card.dataset.i) || null);
  });

  /* ---------------------------------------------------------- A-listers: add */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kal-add]');
    if (!b) return;
    e.preventDefault();
    var card = b.closest('.kal-card'), sel = card && card.querySelector('[data-kal-v]');
    var box = b.closest('[data-kuk-alist]');
    if (!sel || b.disabled) return;
    // no size picked yet: open the size box rather than guess one
    if (!sel.value) {
      sel.classList.add('is-ask'); setTimeout(function () { sel.classList.remove('is-ask'); }, 1400);
      try { sel.showPicker ? sel.showPicker() : sel.focus(); } catch (err) { sel.focus(); }
      return;
    }
    b.disabled = true; b.textContent = 'Adding…';
    // the order line says which row sold it: alist (best sellers in a full
    // basket), alist-match (the rug's own range), alist-empty (empty basket)
    var tag = (box && box.getAttribute('data-upsell')) || 'alist';
    var props = { _upsell: tag };
    // the rug's own runner size (20 Oct 2026): counted on its own, the tag stays as it is
    var ownEl = b.closest('[data-own]');
    if (ownEl) props._runner_size = ownEl.getAttribute('data-own') || 'own';
    post(url('cart_add_url', '/cart/add'), { items: [{ id: Number(sel.value), quantity: 1, properties: props }] })
      .then(function (r) {
        if (!r.ok) throw new Error((r.j && r.j.description) || 'not added');
        track(box ? box.getAttribute('data-where') : 'cart', 'added', card.dataset.h, Number(card.dataset.i) || null);
        refresh(true);
      })
      .catch(function () { b.disabled = false; b.textContent = 'Try again'; });
  });

  /* ---------------------------------------------------------- A-listers: size
     the box shows only the size (a price in it was cut off on a phone); the
     card's price follows the size picked */
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('select[data-kal-v]');
    if (!s) return;
    var o = s.options[s.selectedIndex], pr = s.closest('.kal-card') && s.closest('.kal-card').querySelector('.kal-price');
    if (o && pr && o.getAttribute('data-price')) pr.textContent = o.getAttribute('data-price');
  });

  /* ---------------------------------------------------------- the bar's code
     "Unlocked! Use code GOBIG20": tapping the code applies it below */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kuk-apply]');
    if (!b) return;
    e.preventDefault();
    var f = document.querySelector('[data-kcode-form]');
    if (!f) return;
    var more = f.closest('[data-kcode-more]'); if (more) more.open = true;
    // typed in, not applied: pressing Apply is theirs to do (Jack, 2 Oct)
    var input = f.querySelector('input');
    input.value = b.getAttribute('data-kuk-apply');
    var go = f.querySelector('.kcode-go');
    if (go) { go.classList.add('is-ready'); setTimeout(function () { go.classList.remove('is-ready'); }, 1600); }
  });

  /* ---------------------------------------------------------- discount codes */
  // the codes really working on a basket: from discount_codes where Shopify
  // gives it, else from the discounts it applied (lines and the whole basket)
  function applied(c) {
    var out = [];
    (c.discount_codes || []).forEach(function (d) { if (d.applicable !== false) out.push(d.code); });
    (c.cart_level_discount_applications || []).forEach(function (d) { if (d.type === 'discount_code') out.push(d.title); });
    (c.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var d = a.discount_application || {};
        if (d.type === 'discount_code') out.push(d.title);
      });
    });
    var seen = {};
    return out.filter(function (x) { x = String(x || '').toUpperCase(); if (!x || seen[x]) return false; seen[x] = 1; return true; });
  }
  function current() {
    return fetch(url('cart_url', '/cart'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(applied)
      .catch(function () { return []; });
  }
  function say(msg, bad) {
    var m = document.querySelector('[data-kcode-msg]');
    if (!m) return;
    m.textContent = msg; m.hidden = !msg; m.classList.toggle('is-bad', !!bad);
  }
  function setCodes(codes, done) {
    return post(url('cart_update_url', '/cart/update'), { discount: codes.join(',') }).then(function (r) {
      if (!r.ok) throw new Error('update failed');
      return r.j;
    }).then(function (cart) {
      if (done) done(cart);
      refresh(true);
    });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-kcode-form]');
    if (!f) return;
    e.preventDefault();
    var input = f.querySelector('input'), btn = f.querySelector('button');
    var code = (input.value || '').trim().toUpperCase();
    if (!code) { say('Type or paste a code first', true); return; }
    btn.disabled = true; say('');
    current().then(function (codes) {
      if (codes.map(function (c) { return c.toUpperCase(); }).indexOf(code) >= 0) {
        btn.disabled = false; say(code + ' is already on your basket'); return;
      }
      return setCodes(codes.concat([code]), function (cart) {
        var ok = applied(cart).some(function (c) { return String(c).toUpperCase() === code; });
        // shown after the drawer redraws (the message element is replaced)
        setTimeout(function () {
          if (ok) say(code + ' applied – it’ll be on your order at checkout');
          else say(code + ' isn’t working on this basket – check the spelling, or it may not apply to these items', true);
        }, 700);
      });
    }).catch(function () { btn.disabled = false; say('Couldn’t add that code – you can still enter it at checkout', true); });
  });
  document.addEventListener('click', function (e) {
    var x = e.target.closest && e.target.closest('[data-kcode-remove]');
    if (!x) return;
    e.preventDefault();
    var gone = (x.closest('[data-code]') || {}).getAttribute ? x.closest('[data-code]').getAttribute('data-code') : '';
    x.disabled = true;
    current().then(function (codes) {
      return setCodes(codes.filter(function (c) { return c.toUpperCase() !== String(gone).toUpperCase(); }));
    }).catch(function () { x.disabled = false; });
  });
})();

/* Complete your look (5 Oct 2026). In a full basket, best sellers next to the
   rug a shopper has just chosen can make it feel second best (Jack). So half
   of browsers see the pieces from that rug's own range instead - its runner,
   doormat, circle, cushion - and the other half keep the A-listers, until the
   numbers say which sells more (Upsell Radar -> Meet the A-listers).

     group      localStorage kukoon.alist.ab = match | best, kept for good;
                ?alist_ab=match / =best forces it, for checking
     logged as  term alist:match (the range) / alist:cart (best sellers);
                order lines _upsell = alist-match / alist

   The pieces are chosen the way Complete the set chooses them (kukoon-set.js
   pick(), which only loads on product pages): same product set (ps) as the
   rug, that rug's own range name first, nothing sold out, hidden or already in
   the basket, no underlay, small pieces first. No pieces for this rug - or the
   index can't be reached - and the best sellers stay. Only while A-listers is
   switched on (html.kuk-alist). */
(function () {
  'use strict';
  var S = window.KukoonSearch || {};
  var G = 'best';
  try {
    var f = new URLSearchParams(location.search).get('alist_ab');
    if (f === 'match' || f === 'best') localStorage.setItem('kukoon.alist.ab', f);
    // Upsell Radar picks: the 50/50 test, or everyone on one row. A forced
    // ?alist_ab= (for checking) still wins, for that browser.
    var mode = localStorage.getItem('kukoon.alist.mode') || 'split';
    G = localStorage.getItem('kukoon.alist.ab');
    if (f !== 'match' && f !== 'best' && (mode === 'match' || mode === 'best')) G = mode;
    else if (G !== 'match' && G !== 'best') { G = Math.random() < 0.5 ? 'match' : 'best'; localStorage.setItem('kukoon.alist.ab', G); }
  } catch (e) { G = 'best'; }
  window.KukoonCartAB = G;
  /* Drawer order test (21 Oct 2026, Jack): "runner" puts the rug's own runner
     first (a runner product or the rug's own runner size), then the doormat and
     the rest, with one cushion at most and never first - the popup's runner-first
     made £0.74 a popup against £0.14. "current" keeps today's order. 50/50 per
     browser; ?alist_ord=runner|current forces it. Events carry it in results
     (1 runner, 2 current); the basket carries _alist_ord. */
  var ORD = 'current';
  try {
    var fo = new URLSearchParams(location.search).get('alist_ord');
    if (fo === 'runner' || fo === 'current') localStorage.setItem('kukoon.alist.ord', fo);
    ORD = localStorage.getItem('kukoon.alist.ord');
    if (ORD !== 'runner' && ORD !== 'current') { ORD = Math.random() < 0.5 ? 'runner' : 'current'; localStorage.setItem('kukoon.alist.ord', ORD); }
  } catch (e) { ORD = 'current'; }
  window.KukoonCartOrd = ORD;
  var root = document.documentElement;
  // every A-listers row is drawn here, from the live index: the Liquid copy
  // can repeat products (Shopify answers only ~20 product lookups a page and
  // then hands back earlier ones), so it waits hidden and is only the fallback
  root.classList.add('kuk-alist-js');
  if (G === 'match') root.classList.add('kuk-ab-match');

  var MAX = 6;
  var ORDER = ['doormat', 'bathmat', 'kitchen', 'runner', 'circle', 'rug', 'cushion'];
  var NOUN = { rug: 'rug', runner: 'runner', circle: 'circle', doormat: 'doormat', kitchen: 'kitchen mat', bathmat: 'bath mat', cushion: 'cushion' };
  var has = function (p, t) { return (p.tg || []).indexOf(t) !== -1; };
  function kind(p) {
    var t = p.t || '';
    if (/underlay/i.test(t)) return 'underlay';
    // stair carpets and cut-to-measure lengths are never offered (Jack, 20 Oct 2026) -
    // their names say 'runner', so they were being picked as a rug's runner
    if (/stair|cut to measure/i.test(t) || has(p, 'Stair Carpet')) return 'stair';
    if (has(p, 'Cushion') || /cushion/i.test(t)) return 'cushion';
    if (/bath(room)? mat/i.test(t)) return 'bathmat';
    if (/kitchen mat/i.test(t)) return 'kitchen';
    if (has(p, 'Doormat') || /doormat/i.test(t)) return 'doormat';
    if (has(p, 'Runner Rugs') || /runner/i.test(t)) return 'runner';
    if (has(p, 'Circle') || /\b(circle|round)\b/i.test(t)) return 'circle';
    return 'rug';
  }
  var rangeName = function (p) { var t = p.t || '', i = t.lastIndexOf(' - '); if (/choose your colou?r/i.test(t)) return ''; return i === -1 ? '' : t.slice(i + 3).trim(); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var img = function (u, w) { return u ? u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w : ''; };
  var cap = function (s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; };
  var vid = function (gid) { return String(gid || '').replace(/\D/g, ''); };
  function money(n, code) {
    try {
      return new Intl.NumberFormat((S.locale || 'en') + '-' + (S.country || 'GB'), { style: 'currency', currency: code || S.currencyCode || 'GBP',
        minimumFractionDigits: Number(n) % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(Number(n));
    } catch (e) { return '£' + Number(n).toFixed(2); }
  }

  var indexP = null;
  function index() {
    if (indexP) return indexP;
    // the page's one shared download (theme.liquid, 12 Oct 2026)
    if (window.KukoonIndex) {
      indexP = window.KukoonIndex()
        .then(function (d) { return d.length && 'ps' in d[0] ? d : []; })
        .catch(function () { return []; });
      return indexP;
    }
    var get = function (u) { return fetch(u, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); };
    // the live index carries ps (the product set); the bundled copy may not
    indexP = (S.liveIndexUrl ? get(S.liveIndexUrl) : Promise.reject())
      .then(function (d) { if (!d.length || !('ps' in d[0])) throw new Error('no ps'); return d; })
      .catch(function () { return S.indexUrl ? get(S.indexUrl).then(function (d) { return d.length && 'ps' in d[0] ? d : []; }) : []; })
      .catch(function () { return []; });
    return indexP;
  }
  function cart() {
    return fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function live(handles) {
    if (!S.storefrontToken || !handles.length) return Promise.resolve({});
    var country = /^[A-Z]{2}$/.test(S.country || '') ? S.country : 'GB';
    var parts = handles.map(function (h, i) {
      return 'a' + i + ': product(handle: ' + JSON.stringify(h) + ') { availableForSale variants(first: 40) { nodes { id title availableForSale price { amount currencyCode } } } }';
    });
    return fetch(S.storefrontUrl || '/api/2025-07/graphql.json', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': S.storefrontToken },
      body: JSON.stringify({ query: 'query @inContext(country: ' + country + ') {' + parts.join(' ') + '}' }),
    }).then(function (r) { return r.json(); }).then(function (j) {
      var out = {}; handles.forEach(function (h, i) { out[h] = j && j.data && j.data['a' + i]; }); return out;
    }).catch(function () { return {}; });
  }

  /* what a basket line IS: the size picked, not just the listing. The Cecilia
     rug bought in its 60 x 240 runner size is a runner, so the separate Cecilia
     runner listing is the same thing again, not a piece of the set (Jack, 8 Oct) */
  function lineKind(p, it) {
    var k = kind(p), v = String((it && it.variant_title) || '');
    if (k === 'rug' && /\brunner\b/i.test(v)) return 'runner';
    if (k === 'rug' && /\b(circle|round)\b/i.test(v)) return 'circle';
    return k;
  }
  // the rug the look is built round: the dearest rug, runner or circle in the basket
  function anchor(idx, c) {
    var by = {}; idx.forEach(function (p) { by[p.h] = p; });
    var best = null;
    (c.items || []).forEach(function (it) {
      var p = by[it.handle]; if (!p) return;
      var k = lineKind(p, it); if (k !== 'rug' && k !== 'runner' && k !== 'circle') return;
      if (!best || it.final_line_price > best.price) best = { p: p, price: it.final_line_price };
    });
    return best && best.p;
  }
  /* The pieces, chosen by the SAME rules as the Complete the set popup
     (kukoon-set.js pick(), which only loads on product pages - keep the two
     in step). Before 8 Oct the basket only took the rug's own set, so a Boucle
     jute rug got one runner here and three pieces in the popup (Jack):
       1. the set: same product set (ps), the rug's own range name first, else
          the nearest colour, then the best seller - one per kind
       2. a natural-fibre rug: the plain jute doormat, circle and runner its set
          lacks, proven sellers only
       3. no cushion in the set: one proven cushion in the rug's main colour
     On top of the popup's rules: nothing the basket already has, by the size
     picked - a runner in the basket means no runner offered. */
  var SET_ORDER = {
    rug:    ['doormat', 'bathmat', 'cushion', 'kitchen', 'runner', 'circle'],
    runner: ['doormat', 'bathmat', 'cushion', 'kitchen', 'rug', 'circle'],
    circle: ['doormat', 'cushion', 'bathmat', 'kitchen', 'runner', 'rug'],
  };
  var CUSHION_MIN_SOLD = 20, NATURAL_MIN_SOLD = 5, NATURAL_KINDS = ['doormat', 'circle', 'runner'];
  var CUSHION_FOR = {
    Beige: ['Beige'], Cream: ['Beige'], Ivory: ['Beige'], White: ['Beige'], Natural: ['Beige'],
    Taupe: ['Beige'], Brown: ['Beige'],
    Blue: ['Blue', 'Green'], Navy: ['Blue', 'Green'], Teal: ['Green', 'Blue'],
    Green: ['Green'], Sage: ['Green'], Olive: ['Green'],
    Red: ['Red'], Wine: ['Red'], Burgundy: ['Red'],
    Orange: ['Orange'], Terracotta: ['Orange'], Rust: ['Orange'],
    Multicolour: ['Multicolour'],
  };
  var COLOURS = ['Beige', 'Cream', 'Ivory', 'White', 'Natural', 'Brown', 'Taupe', 'Grey', 'Silver',
    'Charcoal', 'Black', 'Blue', 'Navy', 'Teal', 'Green', 'Sage', 'Olive', 'Red', 'Wine', 'Burgundy',
    'Pink', 'Orange', 'Terracotta', 'Rust', 'Ochre', 'Yellow', 'Gold', 'Purple', 'Multicolour'];
  var FAMILY = {
    Beige: 'n', Cream: 'n', Ivory: 'n', White: 'n', Natural: 'n', Brown: 'n', Taupe: 'n',
    Grey: 'g', Silver: 'g', Charcoal: 'g', Black: 'g',
    Blue: 'c', Navy: 'c', Teal: 'c', Green: 'c', Sage: 'c', Olive: 'c',
    Red: 'w', Wine: 'w', Burgundy: 'w', Pink: 'w', Orange: 'w', Terracotta: 'w', Rust: 'w',
    Ochre: 'w', Yellow: 'w', Gold: 'w', Purple: 'w', Multicolour: 'm',
  };
  function colours(p) {
    var out = {};
    if (p.co) String(p.co).split(/[,/|]/).forEach(function (x) { x = x.trim(); if (x) out[x] = 1; });
    (p.tg || []).forEach(function (t) { if (COLOURS.indexOf(t) !== -1) out[t] = 1; });
    return Object.keys(out);
  }
  function colourScore(rug, other) {
    var rc = colours(rug), cc = colours(other), main = other.co, s = 0;
    cc.forEach(function (x) {
      if (rc.indexOf(x) !== -1) s += x === main ? 3 : 1;
      else if (rc.some(function (r) { return FAMILY[r] && FAMILY[r] === FAMILY[x] && FAMILY[x] !== 'm'; })) s += x === main ? 2 : 0;
    });
    return s;
  }
  function isNatural(p) {
    if (/^(jute|coir|sisal|seagrass)\b/i.test(p.mat || '')) return true;
    return (p.tg || []).indexOf('Jute') !== -1 && !p.wash && !/jute[- ]style/i.test(p.t || '');
  }
  /* Choose Your Colour rugs (20 Oct 2026, Jack): one product, the colour is
     picked as a size. Its product colour is fixed (Green for the jute one),
     so the nearest-colour rules offered the same runner whatever was picked -
     a navy rug got a green runner. Here the picked colour decides: that
     colour's own runner, or no runner at all if it is sold out or unknown.
     Keep this map the same in kukoon-set.js and kukoon-cart.js. */
  var COLOUR_RUNNER = {
    'natural-jute-border-rug-choose-your-colour': {
      navy: 'navy-border-jute-runner-rug-juliette-navy',
      green: 'green-cotton-border-natural-jute-hallway-runner-rug',
      rust: 'terracotta-border-jute-runner-rug-juliette-rust',
      beige: 'beige-cotton-border-natural-jute-area-runner-rug',   // the right one of two near-twins (Jack, 20 Oct)
      black: 'black-border-jute-runner-rug-juliette-black',
      grey: 'grey-blue-cotton-border-natural-hallway-jute-runner-rug'
    },
    'premium-shaggy-rug-choose-your-colour': {
      grey: 'premium-grey-shaggy-runner-rug-dove',
      cream: 'premium-cream-shaggy-runner-rug-lace',
      'sage green': 'premium-sage-green-shaggy-runner-rug-sage'
    }
  };
  // the runner for the colour in a size title like 'Navy / 120cm x 170cm';
  // false = take every runner out and offer none, null = not one of these rugs
  function colourRunner(handle, variantTitle) {
    var m = COLOUR_RUNNER[handle];
    if (!m) return null;
    var parts = String(variantTitle || '').toLowerCase().split('/').map(function (s) { return s.trim(); });
    if (parts.some(function (s) { return /runner/.test(s); })) return false;   // they picked the runner itself
    for (var i = 0; i < parts.length; i++) if (m[parts[i]]) return m[parts[i]];
    return false;
  }
  /* The rug's own runner size (20 Oct 2026, Jack). 86 rugs sell their runner
     as a size of the rug, not as its own product, so nothing above could find
     it - Seraphina's popup fell back to best sellers. These are the ones whose
     runner photo Jack checked one by one (runner-variant-photos-check-2026-10-20):
     rug handle -> its runner size(s) and that photo. The card offers only those
     sizes, adds that size of the same product, and never shows the rug photo
     as a runner. A rug not listed here gets nothing new. Keep this list the
     same in kukoon-set.js and kukoon-cart.js. */
  var RUNNER_SIZE = {
    'beige-linear-bordered-area-rug': { v: ['43617867890843'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/ikaro-rin-RRL-stair-and-floor-final.jpg' },
    'beige-wool-style-rug-tala': { v: ['43758661238939'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/bouclair-tala-00114-overhead-RR-sq.jpg' },
    'brown-spotted-stripes-mat-luna': { v: ['43777493532827'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/20250701_1151_Long_Kitchen_Runner_remix_01jz2sr55re989wbakx18qn0b7.png' },
    'cosy-soft-abstract-lined-beige-moroccan-berber-bedroom-rug': { v: ['43487159845019'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/Medini_20Linea_20Beige_20Insta_5B2_5D.jpg' },
    'cream-beige-boho-rug-sachi': { v: ['43749215436955'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/milako-sachi-00066-RR-overhead-sq.jpg' },
    'distressed-blue-damask-washable-rug': { v: ['43484918481051'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/renuu-BalaBlue-03274.jpg' },
    'faded-distressed-navy-oriental-pattern-rug': { v: ['43486647845019'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/Oscar-Paris-Navy-Close-Up---Traditional-Distrissed-Navy-Living-Room-Rug_5B4_5D.jpg' },
    'gold-abstract-marble-pattern-living-room-rugs': { v: ['43485294559387'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/hatton-marble-gold-22.jpg' },
    'grey-distressed-multicoloured-abstract-living-room-rug': { v: ['43484988997787'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/song-multi-9486_5B5_5D.jpg' },
    'marble-effect-lustre-rug-ori': { v: ['45664219791515'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/Kesia_Ori_Room_web__2_Runner.jpg' },
    'modern-gold-abstract-mosaic-living-room-rugs': { v: ['43485294788763'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/hatton-road-gold-17_5B2_5D.jpg' },
    'modern-soft-grey-gold-distressed-abstract-living-room-rug': { v: ['43484988145819', '56732922511741'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/moonshine-grey-8957_5B2_5D.jpg' },
    'multicolour-medallion-area-rug': { v: ['43627137466523'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/Oscar-joyful-multi-RR-hall-final.jpg' },
    'pastel-tribal-print-area-room-rug': { v: ['43491306373275'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/sable-multi-9542-3_5B1_5D.jpg' },
    'soft-blue-distressed-abstract-living-room-area-rug': { v: ['43484985720987', '56733222601085'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/bedtime-blue-9225_5B4_5D.jpg' },
    'soft-modern-blue-grey-painted-canvas-effect-rugs': { v: ['43486634410139'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/Riveria_Artist_Room_web__2_Runner.jpg' },
    'soft-washable-green-floral-rug-seraphina': { v: ['57943613866365'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/soft-washable-romantic-florals-serafina-room-web-kitchen-RRL-copy_05ca53bc-465f-4b10-aa13-53b295da0718.jpg' },
    'traditional-regal-red-rug-navan': { v: ['43822651703451'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/jasmine-navan-05272-RR-overhead_9e539fc9-6a01-405a-8854-ffe7647200c5.jpg' },
    'vintage-distressed-beige-washable-area-rug-aria': { v: ['45185073184923'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/cleo-1006-RRL-overhead-sq_bb21756f-4c10-4f19-a2d9-f6dd1ea313bd.jpg' },
    'washable-blue-berber-style-rug-yasmine': { v: ['57055443812733', '57055443845501'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/washable-everyday-yasmine-RRL-RR-overhead-SQ.jpg' },
    'washable-blue-geometric-rug-plato': { v: ['54932190495101', '54932190527869'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/Everyday-Plato-room-web-RRL-5.jpg' },
    'washable-multicolour-abstract-rug-lissy': { v: ['54922347512189', '54922347544957'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/Everyday-Lissy-room-web-RRL-5.jpg' },
    // photos Jack replaced on the to-sort sheet (20 Oct)
    'blush-pink-stripe-shaggy-rug-murano': { v: ['43486641782939'], im: 'https://www.kukoonrugs.com/cdn/shop/files/murano-blush-stripe-4051_5B2_5D.jpg' },
    'grey-scandi-trellis-rug-ashbee': { v: ['43486660264091'], im: 'https://www.kukoonrugs.com/cdn/shop/files/Ashbee-Hazy-Grey-Room-2---Grey-Cream--Soft-Scandi-Boho-Hygge-Living-Room-Rug-Runner-Mat-Large-Small_zpsztjyr0ag_5B5_5D.jpg' },
    'mottled-stripe-dark-green-shaggy-rug-murano': { v: ['43486641979547'], im: 'https://www.kukoonrugs.com/cdn/shop/files/Murano-Stripe-Dark-Green-Close-Up---Mottled-Shaggy-Living-Room-Rug_5B3_5D.jpg' },
    'scandi-grey-cream-rug-ashbee': { v: ['43486659739803'], im: 'https://www.kukoonrugs.com/cdn/shop/files/Ashbee-Benni-Grey-Room-1---Grey-Cream--Soft-Scandi-Boho-Hygge-Living-Room-Rug-Runner-Mat-Large-Small_zps1xvdanlm_5B1_5D.jpg' },
    // the 'needs a photo' sheet, filled in by Jack (20 Oct). h = offer that product
    // instead (its own runner listing, or the Frank rug's runner sold as 'Bedroom')
    'beige-stripe-shaggy-rug-living-room': { v: ['44100318396571'], im: 'https://www.kukoonrugs.com/cdn/shop/files/kukoon-murano-biege-stripe-4561.jpg' },
    'blue-oriental-distressed-vintage-rug': { v: ['43486648893595'], im: 'https://www.kukoonrugs.com/cdn/shop/files/Oscar_20Sophia_20Navy_20-_20Blue_20Distressed_20Tradational_20Room_20Rug_5B4_5D.jpg' },
    'distressed-ochre-yellow-pastel-soft-living-room-rug': { v: ['43486647582875'], im: 'https://www.kukoonrugs.com/cdn/shop/files/Oscar_20Rugs_201azx_20_46_5B5_5D.jpg' },
    'faded-distressed-grey-geometric-pattern-rug': { v: ['43486643355803'], im: 'https://www.kukoonrugs.com/cdn/shop/files/Oscar-Anise-Grey-Close-Up---Grey-Oriental-Soft-Living-Room-Rug_5B4_5D.jpg' },
    'fern-green-shaggy-rug': { v: ['43486652235931'], im: 'https://www.kukoonrugs.com/cdn/shop/files/Vancouver-Fern-Green-Donnas-2_zps2o6a8z3h_5B4_5D.jpg' },
    'rich-brown-washable-distressed-boho-rug': { v: ['43484948234395'], im: 'https://www.kukoonrugs.com/cdn/shop/files/renuu-Caris_20Multi-03324_5B5_5D.jpg' },
    'washable-distressed-green-medallion-rug': { h: 'washable-green-medallion-runner-rug' },
    'geometric-blue-and-grey-rug': { v: ['43485413867675'], im: 'https://www.kukoonrugs.com/cdn/shop/files/3077-BS22-Marketplace-Shotjpg_5B3_5D.jpg' },
    'light-brown-mottled-shaggy-living-room-rug-murano': { v: ['43486636343451'], im: 'https://www.kukoonrugs.com/cdn/shop/files/kukoon-murano-biege-4266_5B5_5D.jpg' },
    'modern-blue-distressed-abstract-living-room-rug': { v: ['43484985458843'], im: 'https://www.kukoonrugs.com/cdn/shop/files/astia-blue-9038_5B4_5D.jpg' },
    'modern-gold-abstract-distressed-living-room-rugs': { v: ['43485293969563'], im: 'https://www.kukoonrugs.com/cdn/shop/files/Gemini_Generated_Image_rd0s06rd0s06rd0s.png' },
    'modern-green-abstract-distressed-rugs': { v: ['43485295247515'], im: 'https://www.kukoonrugs.com/cdn/shop/files/tweed-olive-green-2_5B5_5D.jpg' },
    'modern-yellow-ochre-distressed-large-living-room-rugs': { v: ['56588762317181'], im: 'https://www.kukoonrugs.com/cdn/shop/files/kukoon-enzo-new-designs-gold-grey-1_5B2_5D.jpg' },
    'mottled-dark-green-shaggy-rug-for-living-room-murano': { v: ['43486638047387'], im: 'https://www.kukoonrugs.com/cdn/shop/files/Murano-Dark-Green-Close-Up---Mottled-Shaggy-Living-Room-Rug_5B4_5D.jpg' },
    'natural-toned-diamond-living-room-rug': { v: ['43487141593243'], im: 'https://www.kukoonrugs.com/cdn/shop/files/warner-natural-3586_5B1_5D.jpg' },
    'navy-mottled-striped-shaggy-living-room-rug-murano': { v: ['43486639587483'], im: 'https://www.kukoonrugs.com/cdn/shop/files/murano-navy-stripe-4093_5B2_5D.jpg' },
    'ochre-grey-fractured-rug': { v: ['43832238014619'], im: 'https://www.kukoonrugs.com/cdn/shop/files/3606-gb15-9.jpg' },
    'ornate-soft-grey-distressed-medallion-living-room-rug': { v: ['43484987621531'], im: 'https://www.kukoonrugs.com/cdn/shop/files/meredith-multi-9072_5B5_5D.jpg' },
    'pink-grey-bordered-framed-living-room-rug': { v: ['43485417963675'], im: 'https://www.kukoonrugs.com/cdn/shop/files/3642-GB43-Insta-Customer-Pic-3_5B4_5D.jpg' },
    'pink-grey-distressed-worn-look-living-room-rug': { v: ['43485417210011'], im: 'https://www.kukoonrugs.com/cdn/shop/files/3639-GB33_Milan-Instagram-Customer-Pic_5B2_5D.jpg' },
    'pink-grey-modern-area-rug': { h: 'pink-grey-modern-geometric-runner-rug' },
    'pink-grey-traditional-patchwork-living-room-rug': { v: ['43485409378459'], im: 'https://www.kukoonrugs.com/cdn/shop/files/kukoon-1572-gb33-4632jpg_5B2_5D.jpg' },
    'premium-cosy-ochre-striped-shaggy-rug-murano': { v: ['43486642372763'], im: 'https://www.kukoonrugs.com/cdn/shop/files/murano-ochre-stripe-3847_5B2_5D.jpg' },
    'soft-abstract-shaggy-rug-cherish': { v: ['55533967507837'], im: 'https://www.kukoonrugs.com/cdn/shop/files/travellercherishmulti_AbstractShaggyRunnerRoomMarketplaceHallRug_2.jpg' },
    'soft-mottled-brown-shaggy-area-rug-camberley': { v: ['43486658298011'], im: 'https://www.kukoonrugs.com/cdn/shop/files/latte-0133_5B5_5D.jpg' },
    'soft-mottled-grey-shaggy-area-rug-camberley': { v: ['43486659477659'], im: 'https://www.kukoonrugs.com/cdn/shop/files/slate-07155_5B5_5D.jpg' },
    'soft-mottled-light-blue-shaggy-area-rug-camberley': { v: ['43486657642651'], im: 'https://www.kukoonrugs.com/cdn/shop/files/confetti-07200_5B5_5D.jpg' },
    'soft-mottled-silver-shaggy-area-rug-camberley': { v: ['43486659248283'], im: 'https://www.kukoonrugs.com/cdn/shop/files/silver-0756_5B2_5D.jpg' },
    'soft-natural-blue-aztec-area-rug': { v: ['43487140642971'], im: 'https://www.kukoonrugs.com/cdn/shop/files/kemp-blue-3123_5B1_5D.jpg' },
    'teal-blue-cloudscape-living-room-rug': { v: ['43491322331291'], im: 'https://www.kukoonrugs.com/cdn/shop/files/times-blue-9607_5B5_5D.jpg' },
    'yellow-grey-distressed-worn-look-living-room-rug': { v: ['43485416980635'], im: 'https://www.kukoonrugs.com/cdn/shop/files/7_20_3_5B2_5D.jpg' },
    'yellow-grey-geometric-triangle-bedroom-rug': { v: ['43485412229275'], im: 'https://www.kukoonrugs.com/cdn/shop/files/2517-gb44-8_5B4_5D.jpg' },
    'yellow-trellis-living-room-area-rug': { v: ['43485415014555'], im: 'https://www.kukoonrugs.com/cdn/shop/files/3512-gb11-3.jpg' },
    'vintage-grey-washed-effect-living-room-rug': { h: 'vintage-grey-washed-effect-bedroom-rug-ludlow', v: ['43484986474651'] }
  };
  // a runner-shaped copy of the rug for the card: its name says runner (so it
  // counts as one), the checked photo, and only the runner size(s) to pick
  function runnerSize(me, index) {
    var r = me && RUNNER_SIZE[me.h];
    if (!r) return null;
    if (r.h) {
      // another listing is this rug's runner
      var src = null;
      for (var j = 0; j < (index || []).length; j++) if (index[j].h === r.h) { src = index[j]; break; }
      if (!src || src.oos || src.hide) return null;
      if (!r.v && /runner/i.test(src.t || '')) return src;
      me = src; r = { v: r.v || [String(src.vid || '')], im: r.im || (src.im || [])[0] };
    }
    var t = me.t || '', i = t.lastIndexOf(' - ');
    var base = (i === -1 ? t : t.slice(0, i)).replace(/\b(area |living room |bedroom )?rugs?\b/ig, '').replace(/\s+/g, ' ').trim();
    var o = {}; for (var k in me) o[k] = me[k];
    o.t = base + ' Runner' + (i === -1 ? '' : t.slice(i));
    o.im = [r.im]; o.ri = ''; o.only = r.v; o.vid = r.v[0];
    o.tg = (me.tg || []).filter(function (g) { return g !== 'Doormat' && g !== 'Circle' && g !== 'Cushion'; });
    return o;
  }
  // the other way round (20 Oct 2026, Jack): they picked the runner size, so the
  // card is the same rug in its rug sizes - main photo, only the non-runner sizes
  function rugSize(me) {
    if (!me || !me.vv) return null;
    var v = [];
    for (var k in me.vv) if (!/runner/i.test(k) && me.vv[k]) v.push(String(me.vv[k]));
    if (!v.length) return null;
    var o = {}; for (var x in me) o[x] = me[x];
    o.t = String(me.t || '').replace(/s*\brunner\b/ig, '');
    o.tg = (me.tg || []).filter(function (g) { return g !== 'Runner Rugs'; });
    o.only = v; o.vid = v[0]; o.ri = ''; o.own = 'rug';
    return o;
  }
  var ORD_RANK = { runner: 1, doormat: 2, bathmat: 3, kitchen: 4, rug: 5, circle: 6, cushion: 7 };
  /* Card names (27 Oct 2026, Jack), as the popup names them: the rug's own range
     is the set - "Otis runner"; anything else must not look like part of it, so
     it says what it is - "Beige cushion", "Jute doormat", "Linden runner" -
     never just "Cushion". */
  function drawerName(p, range) {
    var k = kind(p), own = rangeName(p);
    if (range && own === range) return range + ' ' + NOUN[k];
    if (k === 'cushion') {
      var c = String(p.t || '').replace(/\b(distressed|vintage|bold|cushion|cover)\b/gi, '').replace(/\s+/g, ' ').trim();
      return c ? cap(c) + ' cushion' : 'Cushion';
    }
    if (/^(jute|coir|sisal|seagrass)/i.test(p.mat || '') || /\bjute\b/i.test(p.t || '')) return 'Jute ' + NOUN[k];
    if (own && own.length <= 14 && !/\d/.test(own)) return own + ' ' + NOUN[k];
    return cap(NOUN[k]);
  }
  function pieces(idx, me, c) {
    var out = piecesBase(idx, me, c);
    if (ORD !== 'runner') return out;
    var cushion = false;
    return out.map(function (p, i) { return { p: p, i: i }; })
      .sort(function (a, b) { return (ORD_RANK[kind(a.p)] || 9) - (ORD_RANK[kind(b.p)] || 9) || a.i - b.i; })
      .map(function (x) { return x.p; })
      .filter(function (p) { if (kind(p) !== 'cushion') return true; if (cushion) return false; cushion = true; return true; });
  }
  function piecesBase(idx, me, c) {
    var out = pieces0(idx, me, c);
    // the colour of this rug in the basket (the dearest line, as anchor() picks)
    var line = null;
    (c.items || []).forEach(function (it) { if (it.handle === me.h && (!line || it.final_line_price > line.final_line_price)) line = it; });
    var want = colourRunner(me.h, line && line.variant_title);
    // the runner size of this rug is in the basket and no rug size: offer the rug sizes
    var lines = (c.items || []).filter(function (it) { return it.handle === me.h; });
    if (lines.length && lines.every(function (it) { return /runner/i.test(it.variant_title || ''); })) {
      var rs = !out.some(function (p) { return kind(p) === 'rug'; }) && rugSize(me);
      out = out.filter(function (p) { return kind(p) !== 'runner'; });
      return rs ? [rs].concat(out).slice(0, MAX) : out;
    }
    if (want === null) {
      // the rug's own runner size - unless a runner (any) is in the basket already
      var own = runnerSize(me, idx), hasRunner = false;
      var by = {}; idx.forEach(function (p) { by[p.h] = p; });
      (c.items || []).forEach(function (it) { var q = by[it.handle]; if (q && lineKind(q, it) === 'runner') hasRunner = true; });
      if (own && !hasRunner && !out.some(function (p) { return kind(p) === 'runner'; }))
        out = out.slice(0, MAX - 1).concat([own]);
      return out;
    }
    var at = -1;
    out = out.filter(function (p, i) { if (kind(p) !== 'runner') return true; if (at < 0) at = i; return false; });
    var inCart = {}; (c.items || []).forEach(function (it) { inCart[it.handle] = 1; });
    var r = null;
    if (want) for (var i = 0; i < idx.length; i++) if (idx[i].h === want) { r = idx[i]; break; }
    if (r && !r.oos && !r.hide && !inCart[r.h]) out.splice(at < 0 ? out.length : at, 0, r);
    return out.slice(0, MAX);
  }
  function pieces0(idx, me, c) {
    var inCart = {}; (c.items || []).forEach(function (it) { inCart[it.handle] = 1; });
    var by = {}; idx.forEach(function (p) { by[p.h] = p; });
    var owned = {};
    (c.items || []).forEach(function (it) { var q = by[it.handle]; if (q) owned[lineKind(q, it)] = 1; });
    var mine = kind(me);
    var ok = function (p) {
      var k = kind(p);
      return p.h !== me.h && !p.oos && !p.hide && !inCart[p.h] && k !== 'underlay' && k !== 'stair' &&
        !(owned[k] && (k === 'rug' || k === 'runner' || k === 'circle'));
    };
    var out = [], seen = {};
    var ps = String(me.ps || '').toLowerCase();
    if (ps) {
      var myName = rangeName(me).toLowerCase(), byKind = {};
      idx.forEach(function (p) {
        if (!ok(p) || String(p.ps || '').toLowerCase() !== ps) return;
        var k = kind(p);
        if (k === mine && (k === 'rug' || k === 'runner' || k === 'circle')) return;
        (byKind[k] = byKind[k] || []).push(p);
      });
      Object.keys(byKind).forEach(function (k) {
        var list = byKind[k];
        var same = list.filter(function (p) { return myName && rangeName(p).toLowerCase() === myName; });
        var names = {}; list.forEach(function (p) { names[rangeName(p).toLowerCase()] = 1; });
        if (same.length) list = same;
        else if (Object.keys(names).length > 1) {
          list = list.map(function (p) { return { p: p, sc: colourScore(me, p) }; })
            .sort(function (a, b) { return b.sc - a.sc || (b.p.s || 0) - (a.p.s || 0); })
            .slice(0, 1).map(function (x) { return x.p; });
        }
        list.forEach(function (p) { if (!seen[p.h]) { out.push(p); seen[p.h] = 1; } });
      });
    }
    var natural = isNatural(me);
    if (natural) {
      var haveKind = {}; haveKind[mine] = 1;
      out.forEach(function (p) { haveKind[kind(p)] = 1; });
      NATURAL_KINDS.forEach(function (k) {
        if (haveKind[k]) return;
        var best = idx.filter(function (p) {
          // a plain jute doormat: most coir mats are printed novelty mats
          return ok(p) && !seen[p.h] && kind(p) === k && isNatural(p) && (p.s || 0) >= NATURAL_MIN_SOLD &&
            (k !== 'doormat' || /\bjute\b/i.test(p.t || ''));
        }).sort(function (a, b) { return colourScore(me, b) - colourScore(me, a) || (b.s || 0) - (a.s || 0); })[0];
        if (best) { out.push(best); seen[best.h] = 1; }
      });
    }
    var wanted = CUSHION_FOR[String(me.co || '').split(/[,/|]/)[0].trim()];
    if (!natural && wanted && !out.some(function (p) { return kind(p) === 'cushion'; })) {
      var cush = idx.filter(function (p) {
        return ok(p) && kind(p) === 'cushion' && !seen[p.h] && wanted.indexOf(p.co) !== -1 &&
          (p.s || 0) >= CUSHION_MIN_SOLD && (p.rc || 0) >= 1;
      }).sort(function (a, b) { return wanted.indexOf(a.co) - wanted.indexOf(b.co) || (b.s || 0) - (a.s || 0); })[0];
      if (cush) { out.push(cush); seen[cush.h] = 1; }
    }
    var order = SET_ORDER[mine] || SET_ORDER.rug;
    out.sort(function (a, b) {
      var ca = kind(a) === 'cushion', cb = kind(b) === 'cushion';
      if (ca !== cb) return ca ? 1 : -1;
      return order.indexOf(kind(a)) - order.indexOf(kind(b)) || (b.s || 0) - (a.s || 0);
    });
    return out.slice(0, MAX);
  }

  /* one card. o.name - what it's called; o.add - sizes and an Add button
     (pieces of a set, the empty basket); o.stars - rating line (best sellers) */
  function card(p, v, i, o) {
    var vs = ((v && v.variants && v.variants.nodes) || []).filter(function (n) { return n.availableForSale; })
      .sort(function (a, b) { return Number(a.price.amount) - Number(b.price.amount); });
    if (p.only) vs = vs.filter(function (n) { return p.only.indexOf(vid(n.id)) !== -1; });
    if (!vs.length) return '';
    var url = ((window.routes && window.routes.root_url) || '/').replace(/\/$/, '') + '/products/' + p.h;
    var cur = vs[0].price.currencyCode, from = vs.length > 1 && Number(vs[vs.length - 1].price.amount) > Number(vs[0].price.amount);
    /* o.prefer - the sizes already in the basket: a rug in that size is picked
       for them. o.choose - no size picked until they pick one, so a full
       basket never gets the cheapest 60 x 110 by accident (Jack, 8 Oct). */
    var pref = null;
    if (o.add && vs.length > 1 && o.prefer) vs.forEach(function (n) { if (!pref && o.prefer[sizeKey(n.title)]) pref = n; });
    var blank = o.add && vs.length > 1 && o.choose && !pref;
    var pick = !o.add ? '' : vs.length > 1
      ? '<label class="kal-size"><span class="kal-sr">Size</span><select data-kal-v>' +
        (blank ? '<option value="" selected disabled>Choose a size</option>' : '') + vs.map(function (n) {
          return '<option value="' + vid(n.id) + '" data-price="' + esc(money(n.price.amount, cur)) + '"' + (n === pref ? ' selected' : '') + '>' +
            esc(n.title.replace(/cm x /g, ' x ').replace(/\s+runner$/i, '')) + '</option>'; }).join('') + '</select></label>'
      : '<input type="hidden" data-kal-v value="' + vid(vs[0].id) + '">';
    var shown = pref ? money(pref.price.amount, cur) : (from ? 'From ' : '') + money(vs[0].price.amount, cur);
    var stars = !o.stars ? '' : '<span class="kal-stars">' + (p.rc > 0
      ? '<span aria-hidden="true">&#9733;</span> ' + (Math.round((p.r || 0) * 10) / 10) + ' <span class="kal-rc">(' + p.rc + ')</span>' : '&nbsp;') + '</span>';
    if (o.mini) {
      // three small cards side by side: identical frames with the whole
      // product in them, name and price, the size as plain text you can tap,
      // Add (Jack, 5 Oct: tall cards scrolled, form rows looked like a form)
      return '<li class="kal-card kal-mini" data-h="' + esc(p.h) + '" data-i="' + (i + 1) + '"' + (p.only ? ' data-own="' + (p.own || 'own') + '"' : '') + '>' +
        '<a class="kal-frame" href="' + esc(url) + '" tabindex="-1" aria-hidden="true" data-kal-open>' +
        ((p.im && p.im[0]) ? '<img src="' + esc(img(p.im[0], 240)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<a class="kal-name" href="' + esc(url) + '" data-kal-open>' + esc(cap(o.name)) + '</a>' +
        '<span class="kal-meta">' + (p.rc > 0 ? '<span class="kal-st" aria-label="Rated ' + (Math.round((p.r || 0) * 10) / 10) + ' from ' + p.rc + ' reviews"><span aria-hidden="true">&#9733;</span> ' + (Math.round((p.r || 0) * 10) / 10) + ' <span class="kal-rc">(' + p.rc + ')</span></span>' : '') +
        '<b class="kal-price">' + esc(money(vs[0].price.amount, cur)) + '</b></span>' + pick +
        '<button type="button" class="kal-add" data-kal-add>Add</button></li>';
    }    return '<li class="kal-card" data-h="' + esc(p.h) + '" data-i="' + (i + 1) + '">' +
      '<a class="kal-img" href="' + esc(url) + '" tabindex="-1" aria-hidden="true" data-kal-open>' +
      ((p.im && p.im[0]) ? '<img src="' + esc(img(p.im[0], 360)) + '" alt="" loading="lazy" width="180" height="180">' : '') + '</a>' +
      '<a class="kal-name" href="' + esc(url) + '" data-kal-open>' + esc(o.name) + '</a>' + stars +
      '<span class="kal-price">' + esc(shown) + '</span>' + pick +
      (o.add ? '<button type="button" class="kal-add" data-kal-add>Add</button>' : '') + '</li>';
  }
  // "160cm x 230cm" and "160 x 230" are the same size
  var sizeKey = function (t) { return String(t || '').toLowerCase().replace(/cm|\s+/g, ''); };
  // the sizes of the rugs, runners and circles in the basket
  function basketSizes(idx, c) {
    var by = {}; idx.forEach(function (p) { by[p.h] = p; });
    var out = null;
    (c.items || []).forEach(function (it) {
      var p = by[it.handle], k = p && kind(p);
      if (!it.variant_title || (k !== 'rug' && k !== 'runner' && k !== 'circle')) return;
      (out = out || {})[sizeKey(it.variant_title)] = 1;
    });
    return out;
  }
  var rugName = function (p) { var n = rangeName(p); return n ? n + ' rug' : (p.t || '').split(' ').slice(0, 3).join(' '); };

  // the A-listers list (data-handles), as it stands: in stock, shown, not in the basket, no repeats
  function bestSellers(idx, c, box, max) {
    var by = {}; idx.forEach(function (p) { by[p.h] = p; });
    var inCart = {}; (c.items || []).forEach(function (it) { inCart[it.handle] = 1; });
    var seenH = {}, out = [];
    String(box.getAttribute('data-handles') || '').split(',').forEach(function (h) {
      var p = by[h.trim()];
      if (!p || seenH[p.h] || p.oos || p.hide || inCart[p.h] || out.length >= max) return;
      seenH[p.h] = 1; out.push(p);
    });
    return out;
  }

  // worked out once per basket and row; every redraw of the drawer re-uses it at once
  var memo = {};
  var sig = function (c) { return (c.items || []).map(function (i) { return i.key + 'x' + i.quantity; }).join(',') + '|' + (c.currency || ''); };
  /* The range's photos take whatever height the basket has spare: bigger on a
     tall screen, smaller on a short one, never a scroll it doesn't need
     (Jack, 5 Oct: a fixed size left a gap on one phone and a scroll on
     another). Measured against the drawer's own scrolling area. */
  var FRAME_MIN = 84, FRAME_MAX = 210;
  function fit() {
    var box = document.querySelector('cart-drawer [data-kuk-alist].kal--mini');
    if (!box) return;
    var sc = box.closest('.overflow-y-auto') || box.parentElement;
    var frames = box.querySelectorAll('.kal-frame');
    if (!sc || !frames.length || !sc.clientHeight) return;
    var now = frames[0].getBoundingClientRect().height || FRAME_MIN;
    // the content's own height (scrollHeight never reads less than the box itself)
    var used = 0;
    for (var k = 0; k < sc.children.length; k++) {
      var el = sc.children[k], cs = getComputedStyle(el);
      used += el.getBoundingClientRect().height + parseFloat(cs.marginTop) + parseFloat(cs.marginBottom);
    }
    var pad = parseFloat(getComputedStyle(sc).paddingTop) + parseFloat(getComputedStyle(sc).paddingBottom);
    var slack = sc.clientHeight - pad - used;                // + room to spare, - would scroll
    var want = Math.max(FRAME_MIN, Math.min(FRAME_MAX, Math.floor(now + slack - 2)));
    if (Math.abs(want - now) < 2) return;
    frames.forEach(function (f) { f.style.height = want + 'px'; });
  }
  ['cart-drawer:open', 'kuk:alist-filled'].forEach(function (e) {
    document.addEventListener(e, function () { setTimeout(fit, 80); setTimeout(fit, 500); });
  });
  window.addEventListener('resize', function () { setTimeout(fit, 120); });
  // page dots under a two-to-a-page row: one per page, the current one long
  function dots(box) {
    var row = box.querySelector('.kal-row'), old = box.querySelector('.kal-dots');
    if (old) old.remove();
    if (!row || !box.classList.contains('kal--mini')) return;
    var cards = row.querySelectorAll('.kal-card').length, pages = Math.ceil(cards / 2);
    if (pages < 2) return;
    var d = document.createElement('div'); d.className = 'kal-dots'; d.setAttribute('role', 'tablist');
    for (var i = 0; i < pages; i++) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'kal-dot' + (i ? '' : ' is-on');
      b.setAttribute('aria-label', 'Page ' + (i + 1) + ' of ' + pages); b.setAttribute('data-kal-page', i);
      d.appendChild(b);
    }
    row.insertAdjacentElement('afterend', d);
  }
  function syncDots(row) {
    var box = row.closest('[data-kuk-alist]'), d = box && box.querySelector('.kal-dots');
    if (!d) return;
    var n = d.children.length, max = row.scrollWidth - row.clientWidth;
    var at = max > 0 ? Math.round(row.scrollLeft / max * (n - 1)) : 0;
    [].forEach.call(d.children, function (b, i) { b.classList.toggle('is-on', i === at); });
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target; if (t && t.classList && t.classList.contains('kal-row')) syncDots(t);
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kal-page]'); if (!b) return;
    var row = b.closest('[data-kuk-alist]').querySelector('.kal-row');
    var to = Number(b.getAttribute('data-kal-page')) * (row.clientWidth - 20);
    row.scrollTo({ left: to, behavior: 'smooth' });
    setTimeout(function () { if (Math.abs(row.scrollLeft - to) > 4) row.scrollLeft = to; syncDots(row); }, 450);
  });
  /* The browser's test group on the basket itself, as a hidden cart attribute
     (_alist_ab = match | best). Shopify copies it onto the order, so Upsell
     Radar can compare the two groups on what really matters - how many
     baskets became orders, and what those orders were worth - not only on
     what was added from the row (Jack, 8 Oct 2026). Only once the row has been
     shown in a full basket: a shopper who never saw it is in neither group. */
  var stamped = false;
  function stamp() {
    if (stamped) return;
    stamped = true;
    cart().then(function (c) {
      if (!c.item_count || (c.attributes || {})._alist_ab === G) return;
      return fetch(((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _alist_ab: G, _alist_ord: ORD } }),
      });
    }).catch(function () { stamped = false; });
  }
  function paint(box, m) {
    if (m && m.html && box.getAttribute('data-where') !== 'empty') stamp();
    if (m && m.html) {
      box.classList.toggle('kal--mini', !!m.match);
      if (m.match) {
        box.setAttribute('data-where', 'match');
        box.setAttribute('data-upsell', 'alist-match');
        box.setAttribute('aria-label', m.title);
        var h = box.querySelector('.kal-h'), s = box.querySelector('.kal-sub');
        if (h) h.textContent = m.title;
        if (s) s.textContent = 'From the same range as your rug';
      } else if (G === 'match' && box.getAttribute('data-where') === 'cart') {
        // the range group, but this rug had no pieces: best sellers, tagged so
        // the test compares the two GROUPS, not just what each one saw (8 Oct)
        box.setAttribute('data-upsell', 'alist-fallback');
      }
      var row = box.querySelector('.kal-row');
      if (row) { row.innerHTML = m.html; row.scrollLeft = 0; }
    }
    dots(box);
    box.setAttribute('data-ready', '');
    document.dispatchEvent(new CustomEvent('kuk:alist-filled'));
  }
  function build(box, idx, c) {
    var where = box.getAttribute('data-where');
    var me = where === 'cart' && G === 'match' && anchor(idx, c), list = me ? pieces(idx, me, c) : [];
    if (list.length) {
      var range = rangeName(me);
      return live(list.map(function (p) { return p.h; })).then(function (lv) {
        var html = list.map(function (p, i) { return card(p, lv[p.h], i, { name: drawerName(p, range), add: true, mini: true }); }).join('');
        // a set whose pieces have all sold out since the index was built: best sellers instead
        if (html) return { match: true, html: html, title: range ? 'Complete your ' + range + ' look' : 'Complete the look' };
        return null;
      }).then(function (m) { return m || best(); });
    }
    return best();
    function best() {
      var shop = where === 'empty', items = bestSellers(idx, c, box, shop ? 8 : 6);
      if (!items.length) return Promise.resolve(null);
      return live(items.map(function (p) { return p.h; })).then(function (lv) {
        // a full basket buys from the card too (Jack, 8 Oct 2026): a tap that
        // left the basket for the product page lost the shopper and counted as
        // a sale that never happened. Their own rug's size is picked for them.
        var prefer = shop ? null : basketSizes(idx, c);
        var html = items.map(function (p, i) { return card(p, lv[p.h], i, { name: rugName(p), add: true, stars: true, prefer: prefer, choose: !shop }); }).join('');
        return html ? { html: html } : null;
      });
    }
  }
  /* 12 Oct 2026 (app audit): filled when the drawer opens or on the cart page.
     The drawer is in every page's markup, so filling on load downloaded the
     whole product index on every page for a box almost nobody saw. */
  var drawerOpened = false;
  var onCartPage = /\/cart\/?$/.test(location.pathname);
  document.addEventListener('cart-drawer:open', function () { drawerOpened = true; fill(); });
  function fill() {
    if (!drawerOpened && !onCartPage) return;
    document.querySelectorAll('[data-kuk-alist]:not([data-ready]):not([data-busy])').forEach(function (box) {
      var where = box.getAttribute('data-where');
      if (where !== 'empty' && !root.classList.contains('kuk-alist')) { box.setAttribute('data-ready', ''); return; }
      box.setAttribute('data-busy', '');
      var giveUp = setTimeout(function () { paint(box, null); }, 2500);   // never leave a blank gap
      Promise.all([index(), cart()]).then(function (r) {
        var idx = r[0], c = r[1], key = where + '|' + sig(c);
        if (!idx.length) return null;
        if (memo[key] !== undefined) return memo[key];
        return build(box, idx, c).then(function (m) { memo[key] = m; return m; });
      }).then(function (m) { clearTimeout(giveUp); if (!box.hasAttribute('data-ready')) paint(box, m); })
        .catch(function () { clearTimeout(giveUp); paint(box, null); });
    });
  }
  new MutationObserver(function () { if (document.querySelector('[data-kuk-alist]:not([data-ready]):not([data-busy])')) fill(); })
    .observe(root, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill); else fill();})();

/* Rebuy's widgets (the "Room for one more?" popup, the cart widget) add to the
   basket themselves and never tell this drawer, so the item only appeared
   after a refresh (Jack, 5 Oct 2026). Rebuy announces its adds on document.
   It also announces a "change" every time it loads - including after this
   drawer redraws - so the basket is checked first, and the drawer is only
   redrawn when what's in it really changed. Redraw only, never open: opening
   here popped the cart up on every page. */
(function () {
  var t = null, seen = null;
  function sig(c) { return c ? c.item_count + ':' + c.total_price + ':' + (c.items || []).map(function (i) { return i.key + 'x' + i.quantity; }).join(',') : ''; }
  function cart() {
    return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }
  cart().then(function (c) { if (seen === null) seen = sig(c); }).catch(function () {});
  // any redraw from elsewhere: remember that basket, so it isn't redrawn twice
  document.addEventListener('cart:updated', function () { cart().then(function (c) { seen = sig(c); }).catch(function () {}); });
  function check() {
    clearTimeout(t);
    t = setTimeout(function () {
      cart().then(function (c) {
        var s = sig(c);
        if (seen !== null && s === seen) return;
        seen = s;
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
      }).catch(function () {});
    }, 200);
  }
  ['rebuy:cart.add', 'rebuy:cart.change'].forEach(function (e) { document.addEventListener(e, check); });
})();